import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "sendIcon", "spinnerIcon", "textarea", "inputContainer"]

  connect() {
    if (this.hasTextareaTarget) {
      this.resize()
    }
  }

  resize() {
    if (!this.hasTextareaTarget) return

    this.textareaTarget.style.height = "auto"
    const maxHeight = 120
    const newHeight = Math.min(this.textareaTarget.scrollHeight, maxHeight)
    this.textareaTarget.style.height = `${newHeight}px`
    this.textareaTarget.style.overflowY = newHeight >= maxHeight ? "auto" : "hidden"
  }

  submit(event) {
    if (!this.hasTextareaTarget) return

    const body = this.textareaTarget.value.trim()
    if (body.length === 0) {
      event.preventDefault()
      this.shakeInput()
      this.textareaTarget.focus()
      return
    }
  }

  shakeInput() {
    if (!this.hasInputContainerTarget) return

    const el = this.inputContainerTarget
    el.classList.remove("animate-shake")
    void el.offsetWidth
    el.classList.add("animate-shake")
  }

  removeShake() {
    this.inputContainerTarget.classList.remove("animate-shake")
  }

  showSpinner() {
    this.sendIconTarget.classList.add("hidden")
    this.spinnerIconTarget.classList.remove("hidden")
    this.submitButtonTarget.disabled = true
  }

  hideSpinner() {
    this.sendIconTarget.classList.remove("hidden")
    this.spinnerIconTarget.classList.add("hidden")
    this.submitButtonTarget.disabled = false
  }

  handleKeyDown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }
}